"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("@angular/router");
const material_1 = require("@angular/material");
const app_service_1 = require("../commons/app.service");
const core_1 = require("@ngx-translate/core");
const AppBaseComponent_1 = require("../commons/AppBaseComponent");
const _4d_mapper_1 = require("4d-mapper");
const application_events_service_1 = require("../xs/services/events/application-events.service");
class ContactComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, router, snackBar, dialog, translate, applicationEvents) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.translate = translate;
    }
    onReady() {
        this.resetTicket();
    }
    resetTicket() {
        this.contactUsRequest = {
            subject: '',
            priority: 'normal',
            category: 'question',
            body: ''
        };
    }
    send() {
        this.service.sendSupportTicket(this.contactUsRequest).subscribe(res => {
            this.resetTicket();
            this.openSnackBarSuccess("MAP.GUIDES_DASHBOARD.CONTACT_US.SENT");
        }, err => {
            this.openSnackBarError('MAP.GUIDES_DASHBOARD.CONTACT_US.SENT_ERROR');
        });
    }
}
exports.ContactComponent = ContactComponent;
